import i18n from '@/i18n/index';

// 订单状态的枚举
export enum OrderStatus {
  Created = 'Created',
  Inviting = 'Inviting',
  Invited = 'Invited', // 被邀请
  CreatorRejected = 'Creator_rejected',
  CreatorApplied = 'Creator_applied',
  PendingProductionKickoff = 'Pending_production_kickoff', // 非寄样-待确认
  ApplyRejected = 'Apply_rejected',
  UnderProduction = 'Under_production', // 达人制作稿件 或脚本
  UnderReview = 'Under_review', // 广告主审核稿件 或脚本
  ReviewRejected = 'Review_rejected',
  PendingPublish = 'Pending_publish',
  PublishRejected = 'Publish_rejected', // youtube 链接校验 失败。
  PendingPayment = 'Pending_payment',
  PaymentSubmitted = 'Payment_submitted',
  Paid = 'Paid',
  PaymentFailed = 'Payment_failed',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  UnderRevision = 'Under_revision', // Deprecated 若有未迁移的老数据, 还是需要展示
  PendingProductShipment = 'Pending_Product_shipment', // 待发货
  PendingProductArrival = 'Pending_Product_Arrival', // 发货中
  Pending = 'Pending', // 资源池
  PendingCreatorAddress = 'Pending_creator_address', // 待达人填写地址
  PendingCreatorAccountInfo = 'Pending_creator_account_info', // 待达人填写会员信息
  PendingAccountSetup = 'Pending_account_setup' // 账号待广告主设置
}

// 下一步操作 / 延期申请的枚举
export enum OrderOperateStage {
  CreatorApprove = 'CreatorApprove', // 广告主确认达人
  ProductionKickoff = 'ProductionKickoff', // 达人确认开始制作
  CreatorAddress = 'CreatorAddress', // 达人填写地址
  ProductShipment = 'ProductShipment', // 广告主发货
  CreatorAccountInfo = 'CreatorAccountInfo', // 达人填写账号信息
  AccountSetup = 'AccountSetup', // 广告主给达人设置账号
  ScriptSubmit = 'ScriptSubmit', // 达人提交脚本
  ScriptApprove = 'ScriptApprove', // 广告主审核脚本
  Draft_1_Submit = 'Draft_1_Submit', // 达人提交1稿
  Draft_1_Approve = 'Draft_1_Approve', // 广告主审核1稿
  Draft_2_Submit = 'Draft_2_Submit', // 达人提交2稿
  Draft_2_Approve = 'Draft_2_Approve', // 广告主审核2稿
  Draft_3_Submit = 'Draft_3_Submit', // 达人提交3稿
  Draft_3_Approve = 'Draft_3_Approve', // 广告主审核3稿
  Draft_4_Submit = 'Draft_4_Submit', // 达人提交4稿
  Draft_4_Approve = 'Draft_4_Approve', // 广告主审核4稿
  Draft_5_Submit = 'Draft_5_Submit', // 达人提交5稿
  Draft_5_Approve = 'Draft_5_Approve', // 广告主审核5稿
  FinalSubmit = 'FinalSubmit', // 达人提交最终稿
  OrderComplete = 'OrderComplete' // 广告主完成订单
}

// 订单内容阶段枚举
export enum OrderContentItemStage {
  KickOff = 'KickOff',
  Address = 'Address',
  AccountInfo = 'AccountInfo',
  ContentApproved = 'contentApproved',
  Script = 'Script',
  Draft_1 = 'Draft_1',
  Draft_2 = 'Draft_2',
  Draft_3 = 'Draft_3',
  Draft_4 = 'Draft_4',
  Draft_5 = 'Draft_5',
  Final = 'Final'
}

export enum OrderContentType {
  // https://cxa8mlnnp7j.feishu.cn/wiki/C7AywMdMQiSfcokSbhCcRJ1knmx#YpH3dImSuoA9n3xHUdqcf3ECnud
  DEDICATED_VIDEO = 'Dedicated video',
  INTEGRATED_VIDEO = 'Integrated video',
  VIDEO = 'Video',
  POST = 'Post',
  REELS = 'Reels',
  IMAGE_TEXT = 'Image & Text'
}

// https://cxa8mlnnp7j.feishu.cn/wiki/C7AywMdMQiSfcokSbhCcRJ1knmx#YpH3dImSuoA9n3xHUdqcf3ECnud
export enum OrderContentGenre {
  TUTORIAL = 'Tutorial',
  STORYTELLING = 'Storytelling',
  PRODUCT_DISPLAY = 'Product display',
  TEST_REVIEW = 'Test & review',
  SHOWCASE = 'Showcase',
  NEWS_UPDATE = 'News update'
}

export enum AdsPlatform {
  Youtube = 'youtube',
  TikTok = 'tiktok',
  Instagram = 'instagram',
  Facebook = 'facebook',
  LinkedIn = 'linkedin',
  X = 'x',
  Twitter = 'twitter'
}

export enum lastPromotionalLinkCheckResultStateLists {
  SUCCESS = 'success',
  FAIL = 'fail'
}

// 延期申请状态
export enum POSTPONE_STATUS {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected'
}

// 价格议价状态
export enum OrderPriceNegotiationStatus {
  UnderAdsFirstReview = 'Under_ads_first_review', // 达人首次报价后 等待广告主审核
  UnderAdsReview = 'Under_ads_review', // 非首次广告主审核
  UnderCreatorReview = 'Under_creator_review', // 达人审核
  PendingAdsApproval = 'Pending_ads_approval' // 待广告主支付
}

// 议价历史记录，区分价格是谁提交的
export enum NegotiationHistoryItemType {
  Ads = 'ads',
  Creator = 'creator'
}

// 取消原因类型key值 （这戏新增的有对应的专属对应文案，应该还有其他的状态）
export enum CancelTypeKey {
  CREATOR_WITHDRAW = 'Creator_withdraw',
  CREATOR_REJECTED = 'Creator_rejected',
  CREATOR_REJECTED_PRICE = 'Creator_rejected_price',
  APPLY_REJECTED = 'Apply_rejected',
  CREATOR_NOT_START = 'Creator_not_start',
  OPS_CANCELLED = 'Ops_cancelled',
  OVERDUE = 'Overdue'
}

export const isCancelTypeKey = (value: string): value is CancelTypeKey =>
  (Object.values(CancelTypeKey) as string[]).includes(value);

/** 取消原因文案（运行时取当前语言） */
export const getCancelTypeLabel = (
  cancelType: string,
  priceNegotiationStatus: string
): string | undefined => {
  if (!isCancelTypeKey(cancelType)) return undefined;
  switch (cancelType) {
    case CancelTypeKey.CREATOR_WITHDRAW:
      return i18n.t('order.cancel_type.creator_withdraw', {
        defaultValue: 'You withdrew your interest'
      });
    case CancelTypeKey.CREATOR_REJECTED:
      return i18n.t('order.cancel_type.creator_rejected', {
        defaultValue: 'You declined the invite'
      });
    case CancelTypeKey.CREATOR_REJECTED_PRICE:
      return i18n.t('order.cancel_type.creator_rejected_price', {
        defaultValue: 'You ended negotiation'
      });
    case CancelTypeKey.APPLY_REJECTED:
      if (
        priceNegotiationStatus &&
        (priceNegotiationStatus ===
          OrderPriceNegotiationStatus.UnderCreatorReview ||
          priceNegotiationStatus ===
            OrderPriceNegotiationStatus.PendingAdsApproval)
      ) {
        return i18n.t('order.cancel_type.brand_ended_negotiation', {
          defaultValue: 'Brand ended negotiation'
        });
      } else {
        return i18n.t('order.cancel_type.apply_rejected', {
          defaultValue: 'Brand declined your quote'
        });
      }
    case CancelTypeKey.CREATOR_NOT_START:
      return i18n.t('order.cancel_type.creator_not_start', {
        defaultValue: 'Cancelled for missed deadline'
      });
    case CancelTypeKey.OPS_CANCELLED:
      return i18n.t('order.cancel_type.ops_cancelled', {
        defaultValue: 'Support cancelled the order'
      });
    case CancelTypeKey.OVERDUE:
      return i18n.t('order.cancel_type.overdue', {
        defaultValue: 'Your submission was overdue'
      });
    default:
      return undefined;
  }
};
